import React, {Component} from 'react';
import Loading from "../Common/Loading";
import Actionbar from "../Common/Actionbar";
import Toast from "../Common/Toast";
import {
    AiOutlineFieldTime,
    BsCarFrontFill,
    BsSpeedometer2,
    MdDelete,
    MdOutlineAddCircle,
    TbEdit
} from "react-icons/all";
import API from "../../services/API";
import {toast} from "react-toastify";

class ManageCars extends Component {
    state = {
        cars: [],
        isLoaded: false,
        showModal: false,
        showEditModal: false,
        showDeleteModal: false,
        device : '',
        carName : '',
        mobile : '',

    }
    editCar = () => {
        this.setState({isLoaded: false })
        const request = {
            title : this.state.carName,
            id : this.state.carId,


        }
        API.updateVehicles(request, this.state.carId)
            .then((response) => {
                toast.success(response.message);
                const mobile = window.localStorage.getItem("mobile");
                const password = window.localStorage.getItem("password");

                API.getCarData(mobile,password)
                    .then((response) => {
                        this.setState({isLoaded: true,
                            showEditModal: false,
                            'cars': response.car_act
                        })
                    })
            })
            .catch((error) => {
                this.setState({isLoaded: true })
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
    }
    deleteCar = () => {
        this.setState({isLoaded: false })
        const request = {
            id : this.state.carId,
        }
        API.deleteVehicles(request)
            .then((response) => {
                toast.success(response.message);
                const mobile = window.localStorage.getItem("mobile");
                const password = window.localStorage.getItem("password");

                API.getCarData(mobile,password)
                    .then((response) => {
                        this.setState({isLoaded: true,
                            showDeleteModal: false,
                            'cars': response.car_act
                        })
                    })
            })
            .catch((error) => {
                this.setState({isLoaded: true })
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
    }
    saveCar = () => {
        /*       const mobile = window.localStorage.getItem("mobile");
               const password = window.localStorage.getItem("passwd");
               const params = {
                   use : mobile,
                   pas : password,
                   name : this.state.carName,
                   car_code : this.state.device,
                   phone_device : this.state.mobile,
                   webapp : 1,

               }*/
        toast.warn('ثبت خودرو در حال حاضر امکان پذیر نیست. لطفا بعدا تلاش کنید')
return false;
  /*      API.SaveCar(params)
            .then((response) => {

            })*/
    }
    render() {
        return (
            <React.Fragment>
                {
                    !this.state.isLoaded && <Loading/>
                }
                <Actionbar title='مدیریت خودروها' noBack={0}/>
                <Toast/>
                {
                this.state.showModal &&
                <section className="container-fluid modal-bg max-w-lg">
                    <div className="row rtl">
                        <div className="col-12">
                            <div className="row modal-card">
                                <div className="col-12 text-white text-center py-3 fw-bold">
                                    افزودن خودرو
                                    <div className="form-floating col-12 mt-5">
                                        <input type="text"
                                               className="form-control px-5 bg-transparent text-white text-right "
                                               id="device" name="device"
                                               placeholder="کد دستگاه"
                                               value={this.state.device}
                                               onChange={(val) => {
                                                   this.setState({device: val.target.value});
                                               }}
                                        />
                                        <label htmlFor="mobile" className="ms-2 text-light right-0 small">
                                       کد دستگاه
                                        </label>
                                    </div>
                                    <div className="form-floating col-12 mt-5">
                                        <input type="tel"
                                               className="form-control px-5 bg-transparent text-white text-right "
                                               id="carName" name="carName"
                                               placeholder="نام خودرو"
                                               value={this.state.carName}
                                               onChange={(val) => {
                                                   this.setState({carName: val.target.value});
                                               }}
                                        />
                                        <label htmlFor="mobile" className="ms-2 text-light right-0 small">
                                       نام خودرو
                                        </label>
                                    </div>
                                </div>
                                <div className="form-floating col-12 mt-2">
                                    <input type="tel"
                                           className="form-control px-5 bg-transparent text-white text-right "
                                           id="mobile" name="mobile"
                                           placeholder="شماره سیم ردیاب"
                                           value={this.state.mobile}
                                           onChange={(val) => {
                                               const mobile = val.target.value;
                                               if (mobile.length >= 12) {
                                                   return false;
                                               }
                                               if (mobile.length > 2 && (mobile[0] !== '0' || mobile[1] !== '9')) {
                                                   toast.error('شماره موبایل بایستی با ۰۹ با اعداد انگلیسی شروع شود. شماره سیمکارت دستگاه را درست وارد کنید. ');
                                                   return false;
                                               }
                                               this.setState({mobile: mobile});

                                           }}
                                    />
                                    <label htmlFor="mobile" className="ms-2 text-light right-10 small">
                                        شماره سیم کارت ردیاب
                                          </label>
                                </div>
                                {/*
                                <div className="form-floating col-12 my-2">
                                    <select name="device" id="device"
                                            className='w-100 text-white p-2 text-small-2 bg-transparent border-white rounded '
                                            aria-label="Floating label select"

                                            onChange={(val) => {

                                                this.setState({user: val.target.value});
                                            }}
                                    >
                                        <option value="0">
                                            ردیاب
                                        </option>
                                        <option value="0">
                                            دزدگیر-ردیاب
                                        </option>

                                    </select>

                                </div>*/}

                                <div className="col-7 my-2 ">
                                    <button className='btn bg-success text-white
                                        text-small-1 w-100 p-2'
                                            onClick={this.saveCar}
                                    >
                                      ثبت خودرو
                                    </button>
                                </div>
                                <div className="col-5 my-2">


                                    <button className='btn bg-dark text-white text-small-1 w-100 p-2 '

                                            onClick={() => {
                                                this.setState({showModal: false})
                                            }}
                                    >

                                        انصراف
                                    </button>



                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                }
                {
                this.state.showEditModal &&
                <section className="container-fluid modal-bg max-w-lg">
                    <div className="row rtl">
                        <div className="col-12">
                            <div className="row modal-card">
                                <div className="col-12 text-white text-center py-3 fw-bold">
                                    ویرایش خودرو

                                    <div className="form-floating col-12 mt-5">
                                        <input type="tel"
                                               className="form-control px-5 bg-transparent text-white text-right "
                                               id="carName" name="carName"
                                               placeholder="نام خودرو"
                                               value={this.state.carName}
                                               onChange={(val) => {
                                                   this.setState({carName: val.target.value});
                                               }}
                                        />
                                        <label htmlFor="mobile" className="ms-2 text-light right-0 small">
                                       نام خودرو
                                        </label>
                                    </div>
                                </div>


                                <div className="col-7 my-2 ">
                                    <button className='btn bg-success text-white
                                        text-small-1 w-100 p-2'
                                            onClick={this.editCar}
                                    >
                                      ویرایش خودرو
                                    </button>
                                </div>
                                <div className="col-5 my-2">


                                    <button className='btn bg-dark text-white text-small-1 w-100 p-2 '

                                            onClick={() => {
                                                this.setState({showEditModal: false})
                                            }}
                                    >

                                        انصراف
                                    </button>



                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                }
                {
                this.state.showDeleteModal &&
                <section className="container-fluid modal-bg max-w-lg">
                    <div className="row rtl">
                        <div className="col-12">
                            <div className="row modal-card">
                                <div className="col-12 text-white text-center py-3 fw-bold">
                                    حذف خودرو

                                    <div className="form-floating col-12 mt-5">
                                      آیا از حدف خودرو مطمئن هستید؟
                                        <br/>
                                        <br/>
                                        <span className='text-warning text-small-2'>تمامی اطلاعات خودرو شامل تمامی مسیرهای پیموده شده پاک خواهد شد</span>
                                    </div>
                                </div>


                                <div className="col-7 my-2 ">
                                    <button className='btn bg-danger text-white
                                        text-small-1 w-100 p-2'
                                            onClick={this.deleteCar}
                                    >
                                      حدف خودرو
                                    </button>
                                </div>
                                <div className="col-5 my-2">


                                    <button className='btn bg-dark text-white text-small-1 w-100 p-2 '

                                            onClick={() => {
                                                this.setState({showDeleteModal: false})
                                            }}
                                    >

                                        انصراف
                                    </button>



                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                }
                <section className="container mt-5 pt-3 rtl ">
                    {
                        this.state.cars.map ((car , index) => {
                            return (
                                <div className="row transaction-item mt-2 px-2" key={car.car_code} >

                                    <div className="col-1">
                                        <BsCarFrontFill className='text-primary-color text-big-2' />
                                    </div>
                                    <div className="col-7 mb-3 text-secondary text-small-1">

                                        <span className='title text-primary-color text-big-1'>{car.car_name}</span>
                                        &nbsp;
                                        <span className='text-secondary text-small-2'>{car.car_code}</span>

                                    </div>
                                    <div className="col-1"
                                         onClick={() => {
                                             this.setState({ carId: car.id , showDeleteModal: true })
                                         }}
                                    >
                                        <MdDelete className='text-danger text-big-2' />
                                    </div>
                                    <div className="col-1">
                                        &nbsp;
                                    </div>
                                    <div className="col-1"
                                    onClick={() => {
                                        this.setState({carName: car.car_name, carId: car.id , showEditModal: true })
                                    }}
                                    >
                                        <TbEdit className='text-warning text-big-2' />
                                    </div>
                                    <div className="col-1">
                                        &nbsp;
                                    </div>

                                    <div className="col-6 text-white-50 text-small-3 text-end">
                                        <BsSpeedometer2 className='mx-2' />
                                        {car.speed}
                                        &nbsp;
                                        کیلومتر
                                    </div>
                                    <div className="col-6 text-white-50 text-small-3 text-start">
                                       <AiOutlineFieldTime className='mx-2' />

                                        {car.gdate}

                                    </div>

                                </div>
                            )
                        })
                    }
                    <div className="row fixed-bottom max-w-lg bottom-5">
                        <div className="col-4">&nbsp;</div>
                        <div className="col-8">
                            {
                                !(this.state.showModal ||  this.state.showEditModal ||  this.state.showDeleteModal)&&
                            <button className="btn btn-success w-100"
                                    onClick={() => {
                                        this.setState({showModal: true})
                                    }}
                            >
                                <MdOutlineAddCircle className="mx-2 text-big-2" />
                                افزودن خودروی جدید
                            </button>
                            }
                        </div>
                    </div>
                </section>
            </React.Fragment>
        );
    }
    componentDidMount = () => {
        const mobile = window.localStorage.getItem("mobile");
        const password = window.localStorage.getItem("password");

        if(!mobile && !password ) {
            window.location.replace('/')
        }
        API.getCarData(mobile,password)
            .then((response) => {
                this.setState({isLoaded: true, 'cars': response.car_act})
                setTimeout(() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }, 400)
            })
    }
}

export default ManageCars;